import { ColorOptions } from "@/src/types";
import { StyledMainSection } from "@/styles/global";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components";

const Section = styled(StyledMainSection)``;

const Wrapper = styled.div<{ $background: ColorOptions }>`
  background-color: ${({ theme, $background }) => theme.colors[$background]};
  padding: 40px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 88px 0;
  }
`;

const Container = styled.div`
  overflow: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 0px 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 1512px;
    padding: 0 88px;
    margin: auto;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: max-content;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    width: unset;
  }
`;

type CardProps = {
  $background?: ColorOptions;
};

const CardCss = css<CardProps>`
  border-radius: 14px;
  -webkit-border-radius: 14px;
  -moz-border-radius: 14px;
  overflow: hidden;
  transform: translateZ(0);
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 330px;
  width: 342px;
  max-width: 80vw;
  text-decoration: none;
  scroll-snap-align: start;
  background-color: ${({ theme, $background }) =>
    theme.colors[$background === "white" ? "black" : "white"]};
  color: ${({ theme, $background }) =>
    theme.colors[$background === "white" ? "black" : "white"]};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    cursor: pointer;
    width: 100%;
    display: grid;
    grid-template-columns: 5fr 6fr;
  }
`;

const Card = styled(Link)<CardProps>`
  ${CardCss}
`;

const ExternalCard = styled.a<CardProps>`
  ${CardCss}
  svg {
    transform: rotate(-45deg);
  }
`;

const Image = styled(GatsbyImage)`
  border-bottom: 2px solid ${({ theme }) => theme.colors.black};
  height: 350px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    position: relative;
    height: 100%;
    width: 100%;
    top: initial;
    align-self: initial;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 24px 16px;
  justify-content: space-between;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 32px;
  }
`;

const Button = styled.div`
  width: 100%;
  border: none;
  padding: 4px 0;
  text-decoration: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    p {
      transition: all 0.2s ease-in-out;
    }

    &:hover {
      p {
        opacity: 0.6;
      }
    }
  }
`;

const S = {
  Section,
  Container,
  Image,
  TextWrapper,
  CardWrapper,
  Card,
  ExternalCard,
  Wrapper,
  Button,
};

export default S;
